import { UiSizes } from "@flightpath/coreui/dist/enums";
import { Button, ButtonTypes } from "@flightpath/coreui/dist/ui/Button";
import { useCallback, useState } from "react";
import I18n from "../../../../../core/localization/I18n";
import { IRadioButtonOption, RadioButtonList } from "../../../_forms/RadioButtons";

type SelectSheetProps = {
  sheetNames: string[];
  onContinue: (sheet: string) => Promise<void>;
  onBack?: () => void;
};

export const SelectSheetStep = ({ sheetNames, onContinue, onBack }: SelectSheetProps) => {
  const [isLoading, setIsLoading] = useState(false);
  const [value, setValue] = useState(sheetNames[0]);
  const radioOptions: IRadioButtonOption[] = sheetNames.map(sheet => {
    return {
      key: sheet.toLowerCase(),
      label: sheet,
      inputProps: { value: sheet, name: `controlQuestion` },
      className: "col mr-2"
    };
  });

  const handleOnContinue = useCallback(
    async (data: typeof value) => {
      setIsLoading(true);
      await onContinue(data);
      setIsLoading(false);
    },
    [onContinue]
  );

  return (
    <div className="col d-flex flex-column align-items-center px-8 py-4">
      <h1 className="row">{I18n.t("phrases.uploadStepSelectSheetTitle")}</h1>
      <div className="row my-8">
        {radioOptions?.length > 0 && (
          <RadioButtonList
            id={radioOptions[0].key}
            disabled={false}
            className="d-flex flex-row"
            onItemClick={value => setValue(value.label)}
            options={radioOptions}
            value={value}
          />
        )}
      </div>

      <div className="row d-flex justify-content-between">
        <Button className="mx-2" type={ButtonTypes.OUTLINE_SECONDARY} size={UiSizes.LG} onClick={onBack}>
          {I18n.t("phrases.uploadStepSelectSheetBackButtonTitle")}
        </Button>
        <Button
          className="mx-2"
          type={ButtonTypes.PRIMARY}
          isDisabled={isLoading}
          onClick={() => handleOnContinue(value)}
        >
          <span>{`${I18n.t("phrases.selectSheetNextButtonTitle")}`}</span>
        </Button>
      </div>
    </div>
  );
};
